import styled from 'styled-components';

import inputBase from '../base';

const Select = styled('select')`
  ${inputBase}
`;

export default Select;
